import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { changelogUpdates } from '../data/changelogData';
import './WhatIsNew.css';

function WhatIsNew() {
  const { version } = useParams();
  const navigate = useNavigate();

  // Find the requested version or default to the latest
  const selectedUpdate = version 
    ? changelogUpdates.find(u => u.version === version || u.version === `v${version}`) || changelogUpdates[0]
    : changelogUpdates[0];

  const displayVersion = selectedUpdate.version;
  const displayTitle = selectedUpdate.title || "Platform Evolution";
  const displayDescription = selectedUpdate.description || "Discover the latest enhancements in the DevTracker ecosystem.";
  
  // Normalize changes/points/features
  const displayChanges = selectedUpdate.changes || selectedUpdate.points || [];

  // Icon mapping helper
  const getIcon = (item) => {
    const text = item.toLowerCase();
    if (text.includes('security') || text.includes('ban') || text.includes('identity')) return 'fa-shield-halved';
    if (text.includes('ai') || text.includes('assistant') || text.includes('intel')) return 'fa-wand-magic-sparkles';
    if (text.includes('qr') || text.includes('share') || text.includes('branding')) return 'fa-qrcode';
    if (text.includes('dashboard') || text.includes('layout') || text.includes('ui')) return 'fa-chart-line';
    if (text.includes('notification') || text.includes('broadcast')) return 'fa-bell';
    if (text.includes('reward') || text.includes('points') || text.includes('credits')) return 'fa-gem';
    if (text.includes('fix') || text.includes('bug') || text.includes('resolved')) return 'fa-bug-slash';
    return 'fa-rocket';
  };

  return (
    <div className="whats-new-container page-container animate-up">
      <div className="container">
        <header className="whats-new-header">
          <span className="version-tag">STABLE RELEASE {displayVersion}</span>
          <h1>{displayTitle}</h1>
          <p className="subtitle">{displayDescription}</p>
        </header>

        <div className="features-grid">
          {displayChanges.length > 0 ? (
            displayChanges.map((change, index) => (
              <div key={index} className="feature-card glass-card">
                <div className="feature-icon">
                  <i className={`fa-solid ${getIcon(change)}`}></i>
                </div>
                <h3>Milestone {index + 1}</h3>
                <p>{change}</p>
                <div className="feature-status">
                  <i className="fa-solid fa-circle-check"></i>
                  <span>RELEASED</span>
                </div>
              </div>
            ))
          ) : (
            <div className="admin-status-empty" style={{gridColumn: '1 / -1'}}>
              <i className="fa-solid fa-cloud-moon"></i>
              <p>No milestone details available for this release yet.</p>
            </div>
          )}
        </div>

        <section className="whats-new-cta">
          <div className="cta-content glass-card">
            <h2>Experience the latest features today</h2>
            <p>DevTracker {displayVersion} is designed for high-fidelity professional workflows.</p>
            <div className="cta-actions">
              <button className="btn btn-primary" onClick={() => navigate('/dashboard')}>Go to Dashboard</button>
              <button className="btn btn-secondary" onClick={() => navigate('/changelog')}>View Full History</button>
            </div>
          </div>
        </section>
      </div>

      {/* Background Accents */}
      <div className="whats-new-blob blob-1"></div>
      <div className="whats-new-blob blob-2"></div>
    </div>
  );
}

export default WhatIsNew;
